// extracted by css-extract-rspack-plugin
export default {"cls1":"SignupBanner-cls1_ZUH","cls2":"SignupBanner-cls2_VxZ SignupBanner-cls1_ZUH"};